export const HARDWARE_DOCUMENT_TYPES = ['datasheet', 'install_guide'] as const
export type HardwareDocumentType = (typeof HARDWARE_DOCUMENT_TYPES)[number]

export const COMPONENT_HARDWARE_DATASHEET_TAG = 'Component - Datasheet'
export const COMPONENT_HARDWARE_INSTALL_GUIDE_TAG = 'Component - Install Guide'

export const DOC_TYPE_TO_FILE_TAG: Record<HardwareDocumentType, string> = {
  datasheet: COMPONENT_HARDWARE_DATASHEET_TAG,
  install_guide: COMPONENT_HARDWARE_INSTALL_GUIDE_TAG,
}
